<template>
  <v-menu
    close-delay="50"
    close-on-content-click
    :disabled="!mini"
    nudge-right="5"
    nudge-width="200px"
    offset-x
    open-on-hover
    right
    :rounded="false"
  >
    <template v-slot:activator="{ on }">
      <v-list-item class="sidebar-item" :to="item.router" v-on="on">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          <trans-field transable :value="item"></trans-field>
        </v-list-item-title>
      </v-list-item>
    </template>
    <v-card flat tile width="200px">
      <v-list-item class="sidebar-item" :to="item.router">
        <v-list-item-title>
          <trans-field transable :value="item"></trans-field>
        </v-list-item-title>
      </v-list-item>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    mini: Boolean,
    item: { required: true, type: Object },
  },
}
</script>

<style lang="scss"></style>
